import { NgModule } from '@angular/core';
import { KeyboardKeyDirective } from './keyboard-key.directive';
import { OskInputDirective } from './osk-input.directive';
import { VirtualKeyboardDirective } from './virtual-keyboard.directive';
import { KeyboardComponent } from './keyboard/keyboard.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { TeclasDirective } from './directivas/teclas.directive';
import { TecladoNumericoView } from './numerico/teclado-numerico.view';
import { OskInputNumDirective } from './directivas/osk-input-num.directive';
import { PosTecladoVirtual } from '../../views/pos/componentes/keyboard/pos-teclado-virtual';
import { DragDropModule } from '@angular/cdk/drag-drop';
const componentes = [KeyboardKeyDirective,
  OskInputDirective, OskInputNumDirective,
  VirtualKeyboardDirective, KeyboardComponent, PosTecladoVirtual,
  TeclasDirective, TecladoNumericoView];
@NgModule({
  imports: [ReactiveFormsModule, CommonModule, FlexModule, MatIconModule, DragDropModule],
  exports: componentes,
  declarations: componentes,
}) export class TecladoModule {

}
